// extracted by mini-css-extract-plugin
export var container = "_dl-1";
export var cornerButtonContainer = "_dl-6";
export var disabled = "_dl-2";
export var dragActive = "_dl-3";
export var fileContainer = "_dl-5";
export var hiddenInput = "_dl-4";
export var widthContainer = "_dl-0";